import UserNotification from "util/UserNotification";
import { createAuthBackend, updateAuthBackend } from "hooks/useAuthentication";
import { onOidcBackendUpdate } from "authentication/components/oidc/bindings";
export const handleCreate = async (payload, formValues, _backendGroupSyncIsActive, shouldUpdateGroupSync = true) => {
  const notifyOnSuccess = () => UserNotification.success("Authentication service was updated successfully.", "Success");
  const notifyOnError = (error) => UserNotification.error(`Updating authentication service failed with status: ${error}`, "Error");
  try {
    const result = await createAuthBackend(payload);
    if (result.backend && formValues.synchronizeGroups && shouldUpdateGroupSync) {
      return onOidcBackendUpdate(false, formValues, result.backend.id, formValues.type).then(notifyOnSuccess);
    }
    notifyOnSuccess();
    return result;
  } catch (error) {
    notifyOnError(error);
    throw error;
  }
};
export const handleUpdate = async (payload, backendId, formValues, backendGroupSyncIsActive, shouldUpdateGroupSync = true) => {
  const notifyOnSuccess = () => UserNotification.success("Authentication service was updated successfully.", "Success");
  const notifyOnError = (error) => UserNotification.error(`Updating authentication service failed with status: ${error}`, "Error");
  try {
    const result = await updateAuthBackend(backendId, {
      ...payload,
      id: backendId
    });
    if (result.backend && shouldUpdateGroupSync) {
      return onOidcBackendUpdate(backendGroupSyncIsActive, formValues, result.backend.id, formValues.type).then(
        notifyOnSuccess
      );
    }
    notifyOnSuccess();
    return result;
  } catch (error) {
    notifyOnError(error);
    throw error;
  }
};
